<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" v-on:emitForm="close"></insertForm>

    <v-card-title>
      <h2>Project Cash Statement</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.financial_year }}</td>
        <td class="text-xs-left">{{ props.item.quarter_name }}</td>
        <td class="text-xs-left">{{ props.item.ta_credit_A | currency }}</td>
        <td class="text-xs-left">{{ props.item.ta_credit_B | currency }}</td>
        <td class="text-xs-left">{{ props.item.ol_credit_A | currency }}</td>
        <td class="text-xs-left">{{ props.item.ol_credit_B | currency }}</td>       
        <td class="text-xs-center">
          <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>

        <td class="justify-center layout px-0">
          <!-- <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon> -->
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>          
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./dataForm";
import Axios from "axios";
import ServerPath from "../../../server-path/server-path";

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,
    public_path: "",

    formSchema: {
      id: 0,
      years: "",
      start_date: "",
      end_date: "",
      is_active:0,

      projectDoc_id:0,
      document_file_name:'',

      Q1_total_A:"0.000",
      Q1_total_B:"0.000",
      Q2_total_A:"0.000",
      Q2_total_B:"0.000",
  

      quater:[
        {
          q1_creditA:0.00,
          q1_creditB:0.00,
          q2_creditA:0.00,
          q2_creditB:0.00,
        },
        {
          q1_creditA:0.00,
          q1_creditB:0.00,
          q2_creditA:0.00,
          q2_creditB:0.00,
        }
      ], 
    },

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Financial Year",
        align: "left",
        sortable: true,
        value: "financial_year"
      },
      {
        text: "Quarter",
        align: "left",
        sortable: true,
        value: "quarter_name"
      },
      {
        text: " TA Credit A",
        align: "left",
        sortable: true,
        value: "ta_credit_A"
      },
      {
        text: " TA Credit B",
        align: "left",
        sortable: true,
        value: "ta_credit_B"
      },
      {
        text: " Onlending Credit A",
        align: "left",
        sortable: true,
        value: "ol_credit_A"
      },
      {
        text: "Onlending Credit B",
        align: "left",
        sortable: true,
        value: "ol_credit_B"
      },
      { text: "Status", align: "center", value: "is_active" },
      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },    
  }),

  /*------------Datatable------------*/
  created() {

    this.public_path =
      ServerPath.serverPath + "/assets/projectInfo/yearlyProjectBudget/";
  },

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },
  // mounted() {
  //   this.getDataFromApi().then(data => {
  //     this.desserts = data.items;
  //     this.totalDesserts = data.total;
  //   });
  // },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {


    addDetails(index, id)
    {
      sessionStorage.setItem("proId", id); 
      this.$router.push('/project-info/project-forcust-report-detail');
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let sls = search.split("/");
        //console.log('sls.length', sls.length);
        if(sls.length == 3)
        {
          search = this.changeFormateYMD(search);
        }

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "pro_forecast_get")
          .then(res => {
            let items = res.data;

            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
      window.open(url);      
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
    
        this.row_index = index

        commonService.getAllDataById(item.id, "get-forcust-detail").then(res => {

          if(res.status == 1)
          {           
            this.formSchema = {...item};
            this.formSchema.quater = {...res.data};
            this.formSchema.start_date = this.changeFormateDMY(
              item.start_date
              );
            this.formSchema.end_date = this.changeFormateDMY(
              item.end_date
              );            
          }
          else
          {
            this.formSchema = {...item};  
            this.formSchema.quater = [{
                  category:"",
                  q1_creditA:"",
                  q1_creditB:"",
                  q2_creditA:"",
                  q2_creditB:"",
                  q3_creditA:"",
                  q3_creditB:"",
                  q4_creditA:"",
                  q4_creditB:"",
                },
                {
                  category:"",
                  q1_creditA:"",
                  q1_creditB:"",
                  q2_creditA:"",
                  q2_creditB:"",
                  q3_creditA:"",
                  q3_creditB:"",
                  q4_creditA:"",
                  q4_creditB:"",
                }];

           /* this.formSchema.start_date = this.changeFormateDMY(
              item.start_date
              );
            this.formSchema.end_date = this.changeFormateDMY(
              item.end_date
              );*/
          }
            
        });

        /*this.formSchema.start_date = this.changeFormateDMY(
          this.formSchema.start_date
        );
        this.formSchema.end_date = this.changeFormateDMY(
          this.formSchema.end_date
        );
          }
*/
        //console.log("formSchema == ", this.formSchema);

        window.scrollTo({
          top: 0,
          left: 100,
          behavior: "smooth"
        });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "project-forcust-report").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.getDataFromApi();
          this.SnackbarVal.color = "success"
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.totalDesserts += 1;
          $this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          $this.$set($this.desserts, $this.row_index, { ...res.data });
          $this.row_index = "";
        }
        this.SnackbarVal.color = "success"
      }
      window.scrollTo({
        left: 0,
        top:
          document.body.scrollHeight || document.documentElement.scrollHeight,
        behavior: "smooth"
      });
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/project_forcust_report/listTable.vue